import { render } from "./HeroBannerForm.vue?vue&type=template&id=f6b5ec48"
import script from "./HeroBannerForm.vue?vue&type=script&lang=js"
export * from "./HeroBannerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__